export { TranslatedContentType } from './TranslatedContentType';
